<template>
    <div>

        <form name='form' v-on:submit.prevent="sendForm(formdata)">
            <div class="row whole">
                <div class="col-7 col-md-5 col-lg-4" style="text-align: left;">

                    <div class="line row">
                        <div class="icon">
                            <i class="fa fa-user"></i>
                        </div>
                        <div class="col-4">
                            <input type="text" v-model="formdata.name" required placeholder="Vorname *">
                        </div>
                        <div class="col-4">
                            <input type="text" v-model="formdata.surname" required placeholder="Name *">
                        </div>
                    </div>

                    <div class="line row">
                        <div class="icon">

                            <i class="fa fa-envelope"></i>
                        </div>
                        <div class="col-8">
                            <input type="email" v-model="formdata.email" required placeholder="E-Mail *">
                        </div>
                    </div>
                    <div class="line row">
                        <div class="icon">

                            <i class="fa fa-phone"></i>
                        </div>
                        <div class="col-8">
                            <input type="text" v-model="formdata.thema" placeholder="Thema">
                        </div>

                    </div>
                    <div class="line row">
                        <div class="icon">

                            <i class="fa fa-comment"></i>
                        </div>
                        <div class="col-8">
                            <textarea rows="5" v-model="formdata.message" required
                                      placeholder="Nachricht *"></textarea>
                            <textarea rows="5" v-model="formdata.hmessage" style="opacity: 0;height: 0;"
                                      placeholder="Nachricht"></textarea>
                            * - Pflichtfelder
                            <input type="hidden" v-model="formdata.formtype">
                        </div>
                    </div>
                <div class="line row">

                    <div class="col-8"
                         style="display: flex;justify-content: start;align-items: center;text-align: left;font-size: 14px;">
                        <input type="checkbox" id='dsgvo' v-model="formdata.dsgvo"
                               style="min-width: 50px;width: 50px;height: 15px;" required>
                        <label for="dsgvo" style="margin-bottom: 0;font-size: 0.9em;line-height: 1.2em;">

                            <div>

                                * Zustimmung zur Datenspeicherung.
                                Dieses Formular speichert die angegebenen Daten sowie Ihre IP-Adresse zwecks
                                Kontaktaufnahme und Spamprüfung. Weitere Informationen finden Sie auf unserer Seite der
                                <a href="/datenschutz" target="_blank">Datenschutzbestimmungen</a>.

                            </div>
                        </label>
                    </div>
                </div>
                </div>
            </div>
            <div class="row whole d-none">
                <div class="col-8 col-md-6 ">
                    <Filtermenu nosearch="true">
                    </Filtermenu>
                </div>
            </div>
            <div class="line row whole justify-content-center" v-if="!errorsent && !justsent">
                <div class="col-8 col-md-2 ">
                    <button class="submit" type="submit" id="submitbutton">
                        <i class="fa fa-paper-plane"></i>&nbsp;
                        Absenden
                    </button>
                </div>
            </div>
            <div id="error" class=" " v-if="errorsent">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" style="width: 100%;text-align: center">Sorry!</h5>
                        </div>
                        <div class="modal-body">
                            Die Nachricht konnte nicht gesendet werden.
                        </div>

                    </div>
                </div>
            </div>
            <div id="success" class="" v-if="justsent">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" style="width: 100%;text-align: center">Danke!</h5>
                            <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close">-->
                            <!--<span aria-hidden="true">&times;</span>-->
                            <!--</button>-->
                        </div>
                        <div class="modal-body">
                            Vielen Dank! Wir haben Ihre Nachricht erhalten. In Ihrem Postfach finden Sie eine
                            Bestätigungsmail.
                        </div>

                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: 'Smallform',
        data() {
            return {
                formdata: {formtype: 'small'},
                justsent: false,
                errorsent: false
            }
        },
        created: function () {

        },
        methods: {},
        components: {
            Filtermenu: () => import('@/components/layouts/Filtermenu'),
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" type="text/scss" scoped>
    #filter {
        top: 0 !important;
    }

    .street {
        @include mobile {

            margin-bottom: 10px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/layouts/Smallform.vue